import React, { useEffect, useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { ColumnDef } from '@tanstack/react-table';
import DataTable from '../../common/DataTable';
import api from '../../../services/api';

interface Props {
  personaId: string;
}

interface WorkflowEntry {
  workflow_id: string;
  phase_label: string;
  persona_role: string;
  created_at: string;
}

const columns: ColumnDef<WorkflowEntry, any>[] = [
  { accessorKey: 'phase_label', header: 'Phase' },
  { accessorKey: 'persona_role', header: 'Role', size: 100 },
  { accessorKey: 'workflow_id', header: 'Workflow', cell: ({ getValue }) => (getValue() as string).slice(0, 8) + '...' },
  {
    accessorKey: 'created_at',
    header: 'Date',
    cell: ({ getValue }) => new Date(getValue() as string).toLocaleDateString(),
  },
];

const WorkflowHistory: React.FC<Props> = ({ personaId }) => {
  const { darkMode } = useTheme();
  const [entries, setEntries] = useState<WorkflowEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/cross-system/links/persona/${personaId}?link_type=assigned_to`)
      .then(r => {
        const links = r.data || [];
        setEntries(links
          .filter((l: any) => l.source_type === 'workflow_phase')
          .map((l: any) => ({
            workflow_id: l.metadata?.workflow_id || l.source_id,
            phase_label: l.metadata?.phase_label || 'Unknown',
            persona_role: l.metadata?.persona_role || 'Contributor',
            created_at: l.created_at,
          }))
        );
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [personaId]);

  return (
    <DataTable
      columns={columns}
      data={entries}
      isLoading={loading}
      emptyMessage="No workflow participation recorded yet."
      searchable
      searchPlaceholder="Search phases..."
    />
  );
};

export default WorkflowHistory;
